module.exports = __webpack_public_path__ + "img/42.78baa321.png";